export default function gridReducer(state, action) {
  switch (action.type) {
    case 'setNewLayout':
      const prevState = {...state}
      const {newX, newY, layout} = action.payload
      const isThreeCols = layout.some(box => box.x === 2)
      const isTwoCols = layout.some(box => box.y === 8) && layout.every(box => box.y <= 10)
      
      if (isThreeCols) {
        const newLayout = [...layout]

        newLayout.forEach(box => {
          if (box.y === 6) {
            box.y = newY;
            box.x = newX;
          }
        })

        return ({
          ...prevState,
          lg: newLayout
        })
      } else if (isTwoCols) {
        const newLayout = [...layout]

        newLayout.forEach(box => {
          if (box.y === 10) {
            box.y = newY;
            box.x = newX
          }
        })

        return ({
          ...prevState,
          sm: newLayout 
        })
      } else {
        return (
          {...prevState}
        )
      }
    default:
      return state
  }
}